import { apiService } from './index';

export const asyncSavePQR = async (data: any): Promise<any> => {
    const { items }: any = await apiService.post(`/api/pqr`, data);
    return items || [];
};
